import { Guid } from "@/types"
import Notification, { IGetNotification, NotificationType } from "./Notification"
import  NotificationAsset  from 'models/NotificationAsset';

export interface IGetNotificationAssetSplittingFailedDto extends IGetNotification {
    notificationType: NotificationType.splitAssetFailed
    assetId: Guid
}

export default class NotificationAssetSplittingFailed extends Notification {
    asset:NotificationAsset

    constructor(dto: IGetNotificationAssetSplittingFailedDto) {
        super(dto)
        this.asset = new NotificationAsset({assetId:dto.assetId})
    }
}
